import { PageModel, PageStatus } from "../../../shared/model/page-model";
import completeImage from "../../../assets/images/icon-success-lg.svg";
import registerImage from "../../../assets/images/simplyhealth_logo.png";

import { updatePageModelReducer } from "../../../shared/model/page-model-reduers";

export function updatePageModelForStatusChangeReducer(pageModel: PageModel, pageStatus: PageStatus): PageModel {
  let { title, informationMessages, buttonTitle, titleImage, showButton, showFooter } = pageModel;
  titleImage = registerImage;
  switch (pageStatus) {
    case "Ready":
      title = "Complete your registration";
      informationMessages = ["Sorry, we need two more pieces of information to make sure that we match you to the correct customer record.", "This service is for Simplyhealth policyholders only."];
      buttonTitle = "Next";
      showButton = true;
      showFooter = true;
      break;
    case "Sending":
      title = "Please wait";
      informationMessages = ["Sending details to register you for access."];
      buttonTitle = "Sending";
      showButton = true;
      showFooter = true;
      break;
    case "Succeeded":
      title = "Success";
      buttonTitle = "";
      titleImage = completeImage;
      showButton = false;
      showFooter = true;
      break;
    case "Failed":
      // see register-response-code-helper for failure messages.
      buttonTitle = "Retry";
      showButton = true;
      showFooter = true;
      break;
    case "Missing Query Parameters":
      title = "Not Authorised";
      buttonTitle = "";
      informationMessages = ["Unable to determine client application."];
      showButton = false;
      showFooter = false;
      break;
  }
  return updatePageModelReducer(pageModel, {
    title,
    informationMessages,
    buttonTitle,
    titleImage,
    showButton,
    showFooter
  });
}
